import React, { useState } from 'react';

import ServiceRequestList from './ServiceRequestList';

import classes from './ServiceManagement.module.css';


const TableContainer = ({
    ...props
}) => {
    const [serviceRequestActionModalOpen, handleToggleServiceRequestActionModal] = useState(false);
    const [createServiceRequest, handleToggleCreateServiceRequest] = useState(false);

    return (
        <div className={classes.TableContainer}>
            <div className={classes.GridContainer}>
                <ServiceRequestList
                    serviceRequestActionModalOpen={serviceRequestActionModalOpen}
                    createServiceRequest={createServiceRequest}
                    handleToggleCreateServiceRequest={(value) => handleToggleCreateServiceRequest(value)}
                    handleToggleServiceRequestActionModal={(value) => handleToggleServiceRequestActionModal(value)}
                />
            </div>
        </div>
    );
};

export default TableContainer;
